module.exports = __webpack_public_path__ + "img/logoHidalgobg.053ed2a8.png";